<template>
  <div class="pagoda-advanced-search-wrapper">
    <pagoda-form-group
      :value="baseFormData"
      :form-options="baseFormOptions"
      @input="handleBaseFormInput"
      v-bind="$attrs"
      ref="baseForm"
    >
      <slot></slot>
      <template :slot="option.key" v-for="option in baseFormOptions">
        <slot :name="option.key"></slot>
      </template>
      <template slot-scope="scope" :slot="$scopedSlots[option.key] ? option.key : null" v-for="option in baseFormOptions">
        <slot :name="option.key" v-bind="scope"></slot>
      </template>
      <template slot-scope="scope" :slot="`${slotKey}__${slotName}`" v-for="{slotKey, slotName} in baseFormHasNameSlot">
        <slot :name="`${slotKey}__${slotName}`" v-bind="scope"></slot>
      </template>
    </pagoda-form-group>
    <transition name="fade-down">
      <div class="advanced-search" v-show="advancedSearch">
        <div class="advanced-search__header">高级搜索</div>
        <pagoda-form-group
          style="margin-bottom: 20px"
          :value="advancedFormData"
          @input="handleAdvancedFormInput"
          :form-options="advancedFormOptions"
          v-bind="$attrs"
          ref="advancedForm"
        >
          <template :slot="option.key" v-for="option in advancedFormOptions">
            <slot :name="option.key"></slot>
          </template>
          <template slot-scope="scope" :slot="$scopedSlots[option.key] ? option.key : null" v-for="option in advancedFormOptions">
            <slot :name="option.key" v-bind="scope"></slot>
          </template>
          <template slot-scope="scope" :slot="`${slotKey}__${slotName}`" v-for="{slotKey, slotName} in advancedFormHasNameSlot">
            <slot :name="`${slotKey}__${slotName}`" v-bind="scope"></slot>
          </template>
        </pagoda-form-group>
        <pagoda-row-btns :btns="rowBtns" :visibles="btnVisibles"></pagoda-row-btns>
      </div>
    </transition>
    <div class="back-wrapper" v-show="advancedSearch" @click="$emit('update:advancedSearch', false)"></div>
  </div>
</template>

<script>
  import FormGroup from './form-group'
  import RowBtns from '../button/row-btns'

  export default {
    name: 'AdvancedSearch',
    inheritAttrs: false,
    props: {
      value: {
        required: true
      },
      formOptions: {
        required: true,
        type: Array
      },
      advancedSearch: Boolean
    },
    computed: {
      baseFormHasNameSlot () {
        return this.getHasNameSlot(this.baseFormOptions)
      },
      advancedFormHasNameSlot () {
        return this.getHasNameSlot(this.advancedFormOptions)
      },
      baseFormData () {
        let value = {}

        this.baseFormOptions.forEach(({key}) => {
          if (key in this.value) {
            value[key] = this.value[key]
          }
        })

        return value
      },
      advancedFormData () {
        let value = {}

        this.advancedFormOptions.forEach(({key}) => {
          if (key in this.value) {
            value[key] = this.value[key]
          }
        })

        return value
      }
    },
    data () {
      return {
        rowBtns: {
          cancel: {
            text: '取消',
            onClick: () => this.$emit('update:advancedSearch', false)
          },
          enter: {
            text: '确认',
            type: 'primary',
            props: {
              plain: false
            },
            onClick: () => this.$emit('update:advancedSearch', false)
          },
          reset: {
            text: '清空',
            type: 'text',
            onClick: this.handleAdvancedFormReset
          }
        },
        btnVisibles: ['cancel', 'enter', 'reset'],
        baseFormOptions: [],
        advancedFormOptions: []
      }
    },
    methods: {
      getFormRefs () {
        return {...this.$refs.baseForm.getFormRefs(), ...this.$refs.advancedForm.getFormRefs()}
      },
      getHasNameSlot (formOptions) {
        let result = []

        for(const [name, slot] of Object.entries(this.$scopedSlots)) {
          const [slotKey, slotName] = name.split('__')

          if(slotName && formOptions.find(({key}) => key === slotKey)) {
            result.push({
              slotKey,
              slotName
            })
          }
        }

        return result
      },
      handleBaseFormInput (newVal) {
        this.$emit('input', Object.assign({}, newVal, this.advancedFormData))
      },
      handleAdvancedFormInput (newVal) {
        this.$emit('input', Object.assign({}, this.baseFormData, newVal))
      },
      handleAdvancedFormReset () {
        this.$refs.advancedForm.reset()
      },
      reset () {
        this.$refs.baseForm.reset()
        this.$nextTick(this.$refs.advancedForm.reset)
      },
      validate () {
        return this.$refs.baseForm.validate()
      }
    },
    watch: {
      formOptions: {
        immediate: true,
        handler () {
          let baseFormOptions = []
          let advancedFormOptions = []

          this.formOptions.forEach(formItem => {
            if(formItem.advancedSearch) {
              advancedFormOptions.push(formItem)
            }else {
              baseFormOptions.push(formItem)
            }
          })

          this.baseFormOptions = baseFormOptions
          this.advancedFormOptions = advancedFormOptions
        }
      }
    },
    components: {
      'pagoda-form-group': FormGroup,
      'pagoda-row-btns': RowBtns
    }
  }
</script>
